import React from 'react';
import LoginForm from '../LoginForm';
import SignupForm from '../SignupForm';
import ForgotPasswordForm from '../ForgotPasswordForm';
import ResetPasswordForm from '../ResetPasswordForm';
import { AuthModalProps } from './types';
import './styles.scss';

const AuthModal: React.FC<AuthModalProps> = ({ authView, setAuthView, setShowAuthModal }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={() => setShowAuthModal(false)}>×</button>

        {authView === 'login' && <LoginForm setAuthView={setAuthView} />}
        {authView === 'signup' && <SignupForm setAuthView={setAuthView} />}
        {authView === 'forgot' && <ForgotPasswordForm setAuthView={setAuthView} />}
        {authView === 'reset' && (
          <ResetPasswordForm
            setAuthView={setAuthView}
            onComplete={() => setShowAuthModal(false)}
          />
        )}
      </div>
    </div>
  );
};

export default AuthModal;
